import { create } from './Create/Create.i18n.en'
import { detail } from './Detail/Detail.i18n.en'
import { list } from './List/List.i18n.en'
import { update } from './Update/Update.i18n.en'

export const washingMethods = {
  list,
  create,
  update,
  detail,
}
